import { render } from "./ShowPubPer.vue?vue&type=template&id=39e6819e&scoped=true"
import script from "./ShowPubPer.vue?vue&type=script&lang=js"
export * from "./ShowPubPer.vue?vue&type=script&lang=js"

import "./ShowPubPer.vue?vue&type=style&index=0&id=39e6819e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39e6819e"

export default script